function getContentHeight(contentRef) {
  let height = 0;
  if (contentRef !== null && contentRef.current) {
    height = contentRef.current.offsetHeight;
  }
  return height;
}

export { getContentHeight };
//# sourceMappingURL=helpers.es.js.map
